import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {merge} from 'rxjs';
import {HeimvorteilGebaeudeart, HeimvorteilProduktart} from '../../../../shared/enum';
import {CustomValidator} from '../../../../shared/validation';
import { IHvVarianten } from '../../../models/hvvarianten';

@Component({
  selector: 'app-varianten-hv',
  templateUrl: './varianten-hv.component.html',
  styleUrls: ['./varianten-hv.component.scss']
})
export class VariantenHvComponent implements OnInit {

  @Input()
  versicherungsVarianteFormGroup: UntypedFormGroup;

  @Output()
  calculateRatePendingEvent = new EventEmitter<void>();

  @Output()
  loadHvPaketePendingEvent = new EventEmitter<void>();

  produktarten = HeimvorteilProduktart;
  gebaeudearten = HeimvorteilGebaeudeart;

  constructor() { }

  ngOnInit(): void {
    this.onValueChanged();
  }

  onValueChanged(){
    merge(
      this.produktart.valueChanges,
    ).subscribe(() => {
      if (this.produktart && this.produktart.value !== HeimvorteilProduktart.Haushalt) {
        this.gebaeudeart.setValue(null);
      }
    });
    merge(
      this.produktart.valueChanges,
      this.gebaeudeart.valueChanges
    ).subscribe(() => {
      this.calculateRatePendingEvent.emit();
      this.loadHvPaketePendingEvent.emit();
    });
  }

  static createProduktart() {
    return new UntypedFormControl('', Validators.required);
  }
  static createGebaeudeart() {
    return new UntypedFormControl('', CustomValidator.GebaeudeartRequiredValidator);
  }

  get produktart() { return this.versicherungsVarianteFormGroup.get('produktart') as UntypedFormControl; }
  get gebaeudeart() { return this.versicherungsVarianteFormGroup.get('gebaeudeart') as UntypedFormControl; }

  getVariante(): IHvVarianten {
    return {
      Produktart: this.produktart.value,
      Gebaeudeart: this.gebaeudeart.value
    };
  }

  setVariante(variante: IHvVarianten): void {
    this.produktart.setValue(variante.Produktart);
    this.gebaeudeart.setValue(variante.Gebaeudeart);

  }
}
